(function () {

  function initCorporateGifting(section) {
    if (!section) return;

    /* =========================================
       OCCASION SELECTION
    ========================================== */
    const occasionButtons = section.querySelectorAll('.tp-occasion-option');
    const occasionInput = section.querySelector('input[name="contact[Occasion]"]');

    occasionButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        occasionButtons.forEach(function (item) {
          item.classList.remove('active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');

        if (occasionInput) {
          occasionInput.value = button.getAttribute('data-value') || '';
        }
      });
    });

    /* =========================================
       DELIVERY DATE
    ========================================== */
    const dateInput = section.querySelector('input[type="date"]');

    if (dateInput) {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      dateInput.min = year + '-' + month + '-' + day;
    }

    /* =========================================
       FORM → WHATSAPP
       Submit button sends the filled form data
       to the configured WhatsApp number.
    ========================================== */
    const form = section.querySelector('.tp-gifting-form');
    const submitButton = section.querySelector('.tp-main-submit');

    if (form && submitButton) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        function getValue(selector) {
          const field = form.querySelector(selector);
          if (!field) return '';
          return field.value.trim();
        }

        const name = getValue('input[name="contact[name]"]');
        const email = getValue('input[name="contact[email]"]');
        const phone = getValue('input[name="contact[Phone]"]');
        const occasion = getValue('input[name="contact[Occasion]"]');
        const quantity = getValue('input[name="contact[Approx Quantity]"]');
        const budget = getValue('input[name="contact[Budget Per Gift]"]');
        const deliveryDate = getValue('input[name="contact[Delivery Date]"]');
        const company = getValue('input[name="contact[Company Name]"]');
        const requirements = getValue('textarea[name="contact[Special Requirements]"]');

        /* =====================================
           VALIDATION
        ====================================== */
        if (!name) {
          alert('Please enter your name.');
          const field = form.querySelector('input[name="contact[name]"]');
          if (field) field.focus();
          return;
        }

        if (!email) {
          alert('Please enter your email.');
          const field = form.querySelector('input[name="contact[email]"]');
          if (field) field.focus();
          return;
        }

        if (!phone) {
          alert('Please enter your phone / WhatsApp number.');
          const field = form.querySelector('input[name="contact[Phone]"]');
          if (field) field.focus();
          return;
        }

        /* =====================================
           WHATSAPP NUMBER
        ====================================== */
        let whatsappNumber = section.dataset.whatsappNumber || '';

        if (!whatsappNumber) {
          const whatsappButtonForNumber = section.querySelector('.tp-whatsapp');
          if (whatsappButtonForNumber) {
            whatsappNumber = whatsappButtonForNumber.dataset.number || '';
          }
        }

        whatsappNumber = whatsappNumber.replace(/\D/g, '');

        if (!whatsappNumber) {
          alert('Please add a valid WhatsApp number in the Shopify Theme Customizer.');
          return;
        }

        /* =====================================
           CREATE WHATSAPP MESSAGE
        ====================================== */
        let message = 'Hello TRU PAHADI! 👋\n\n';
        message += '*Corporate Gifting Enquiry*\n';
        message += '━━━━━━━━━━━━━━━━━━\n\n';

        if (name) message += '*Name:* ' + name + '\n';
        if (company) message += '*Company:* ' + company + '\n';
        if (email) message += '*Email:* ' + email + '\n';
        if (phone) message += '*Phone:* ' + phone + '\n';
        if (occasion) message += '*Occasion:* ' + occasion + '\n';
        if (quantity) message += '*Approx. Quantity:* ' + quantity + '\n';
        if (budget) message += '*Budget per Gift:* ₹' + budget + '\n';
        if (deliveryDate) message += '*Delivery Date:* ' + deliveryDate + '\n';

        if (requirements) {
          message += '*Special Requirements:*\n' + requirements + '\n';
        }

        message += '\n━━━━━━━━━━━━━━━━━━\n';
        message += 'Please share suitable corporate gifting options and quotation.';

        const whatsappURL =
          'https://wa.me/' +
          whatsappNumber +
          '?text=' +
          encodeURIComponent(message);

        /* =====================================
           BUTTON LOADING
        ====================================== */
        submitButton.disabled = true;
        submitButton.style.opacity = '0.75';
        submitButton.style.cursor = 'wait';

        const buttonText = submitButton.querySelector('span:first-child');
        const originalButtonText = buttonText
          ? buttonText.textContent
          : '';

        if (buttonText) {
          buttonText.textContent = 'Opening WhatsApp...';
        }

        /* =====================================
           OPEN WHATSAPP
        ====================================== */
        const whatsappWindow = window.open(whatsappURL, '_blank');

        if (!whatsappWindow) {
          window.location.href = whatsappURL;
          return;
        }

        /* Restore button after opening WhatsApp. */
        setTimeout(function () {
          submitButton.disabled = false;
          submitButton.style.opacity = '';
          submitButton.style.cursor = '';

          if (buttonText) {
            buttonText.textContent = originalButtonText ||
              section.dataset.submitText ||
              'Get My Corporate Gifting Quote';
          }
        }, 1500);
      });
    }

    /* =========================================
       WHATSAPP DIRECT BUTTON
    ========================================== */
    const whatsappButton = section.querySelector('.tp-whatsapp');

    if (whatsappButton) {
      whatsappButton.addEventListener('click', function (event) {
        event.preventDefault();

        let number = whatsappButton.dataset.number || '';
        let message = whatsappButton.dataset.message || '';

        number = number.replace(/\D/g, '');

        if (!number) {
          alert('Please add a valid WhatsApp number in the Shopify Theme Customizer.');
          return;
        }

        const whatsappURL =
          'https://wa.me/' +
          number +
          '?text=' +
          encodeURIComponent(message);

        const whatsappWindow = window.open(whatsappURL, '_blank');

        if (!whatsappWindow) {
          window.location.href = whatsappURL;
        }
      });
    }
  }

  /* =========================================
     INITIALIZE
  ========================================== */
  function initializeAll() {
    const sections = document.querySelectorAll('.tp-corporate-gifting');

    sections.forEach(function (section) {
      if (section.dataset.tpInitialized === 'true') return;

      section.dataset.tpInitialized = 'true';
      initCorporateGifting(section);
    });
  }

  /* =========================================
     PAGE LOAD
  ========================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  /* =========================================
     SHOPIFY THEME EDITOR
  ========================================== */
  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.tp-corporate-gifting');

    if (section) {
      section.dataset.tpInitialized = 'false';
      initCorporateGifting(section);
    }
  });

})();
